import { DrawCabinetInsideElement } from './DrawCabinetInsideElement';

export class DrawInsideBottleShelf extends DrawCabinetInsideElement {
    Number!: number;
}
